import { render, staticRenderFns } from "./InsuranceTrend.vue?vue&type=template&id=f2f5905e&scoped=true"
import script from "./InsuranceTrend.vue?vue&type=script&lang=js"
export * from "./InsuranceTrend.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTrend.vue?vue&type=style&index=0&id=f2f5905e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f5905e",
  null
  
)

export default component.exports